/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Patient profile routes
 */

// Pages
import MyProfile from '@nephro/pages/PatientProfile';
import ChangePassword from '@nephro/pages/PatientChangePassword';

const pathStart = '/main/my-profile';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: MyProfile,
    exact: true
  },
  {
    path: `${pathStart}/changePassword`,
    isProtected: true,
    component: ChangePassword,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
